import { Search } from 'lucide-react'
import { Input, cn } from '@ludus/ui'
import { useTranslation } from 'react-i18next'

interface SearchInputProps {
  value: string
  onChange: (next: string) => void
  className?: string
}

/**
 * Plain controlled search input. No internal debounce — the consumer
 * (`FiltersBar`) wraps the dispatch in `startTransition`, so React keeps the
 * keystroke responsive while the deals re-render runs as a low-priority update.
 */
export function SearchInput({ value, onChange, className }: SearchInputProps) {
  const { t } = useTranslation()
  return (
    <div className={cn('relative', className)}>
      <Search
        className="pointer-events-none absolute left-2.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted"
        aria-hidden="true"
      />
      <Input
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={t('pages.pipelines.filters.searchPlaceholder', {
          defaultValue: 'Search by deal id, owner, contact…',
        })}
        aria-label={t('pages.pipelines.filters.searchLabel', {
          defaultValue: 'Search deals',
        })}
        className="pl-8"
      />
    </div>
  )
}
